"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = pick;
exports.getCourseId = getCourseId;
function pick(obj, keys) {
    const result = {};
    keys.forEach(key => {
        if (key in obj) {
            result[key] = obj[key];
        }
    });
    return result;
}
function getCourseId() {
    const hash = window.location.hash;
    if (!hash) {
        return null;
    }
    const match = hash.match(/^#\/courses\/([0-9a-fA-F-]{36})(?:\/.*)?$/);
    return match ? match[1] : null;
}
